import { render, staticRenderFns } from "./LocalInfo.vue?vue&type=template&id=3280f646&scoped=true&"
import script from "./LocalInfo.vue?vue&type=script&lang=js&"
export * from "./LocalInfo.vue?vue&type=script&lang=js&"
import style0 from "./LocalInfo.vue?vue&type=style&index=0&id=3280f646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280f646",
  null
  
)

export default component.exports